var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolders = function SvgIconFolders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.375 6.875v-2a1.75 1.75 0 0 1 1.75-1.75h4.251a1.76 1.76 0 0 1 1.043.348l.002.001 2.54 1.901h6.414a1.75 1.75 0 0 1 1.75 1.75v8.334a1.665 1.665 0 0 1-1.666 1.666h-2.084v2.084a1.665 1.665 0 0 1-1.666 1.666H3.375a1.75 1.75 0 0 1-1.75-1.75v-10.5a1.75 1.75 0 0 1 1.75-1.75zm2 0v-1.75h3.914l2.54 1.9.002.002a1.76 1.76 0 0 0 1.043.348h6.251v7.75h-1.75v-4.25a1.75 1.75 0 0 0-1.75-1.75h-6.414l-2.54-1.9-.002-.002a1.76 1.76 0 0 0-1.043-.348h-.251m10 4.25h-6.251a1.76 1.76 0 0 1-1.043-.348l-.002-.001-2.54-1.901H3.625v10h13.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFolders;